<template>
    <div name="card1" class="card">
        <span class="title">“카드 할부가 되었으면 좋겠어요"</span>
        <span class="description" style="margin-top: 20px;">카드 할부 결제 기능 개발</span>
        <img class="image" src="../../../../assets/improvement_3.png" />
        <div class="button" @click="go" style="margin-top: 62px;">
            자세히 보기
        </div>
    </div>
</template>

<script>
export default {
    name: 'card3',
    methods: {
        go: function()
        {
            window.open("https://blog.naver.com/soldoc_concierge/224048749839", "_blank")
        }
    }
}
</script>

<style scoped>
    .card {
        width: 702px;
        height: 260px;
        display: flex;
        flex-direction: column;
        padding: 32px 79.282px 32px 32px;
        border-radius: 18px;
        border: 1px solid var(--Gray-00, #FFF);
        background: var(--Gray-20, #F3F5F8);
        box-sizing: border-box;
        position: relative;
    }
    .image {
        width: 273px;
        position: absolute;
        right: 0;
        bottom: 0px;
        right: 20px;
    }
    .title {
        color: var(--Gray-60, #6B7684);
        font-family: Pretendard;
        font-size: 20px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px; /* 120% */
    }
    .description{
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 24px;
        font-style: normal;
        font-weight: 600;
        line-height: 28px; /* 116.667% */
    }
    .button {
        display: flex;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        border-radius: 6px;
        background: var(--Gray-100, #1E1E1E);
        color: var(--Gray-00, #FFF);
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 18px; /* 112.5% */
        width: 90px;
        height: 34px;
        cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// src/components/molecules/pc_uncomfortable/improvements/Card3.vue